import React, { useEffect } from 'react';
import { Box, Flex, Text, useColorMode } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';
import { BrandLogo } from '../../components/ui';

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { colorMode, setColorMode } = useColorMode();
  const isPortal = pathname.startsWith('/vendor/portal');

  // Vendor register / portal always open in light — no staff JWT, no dark toggle.
  useEffect(() => {
    if (colorMode !== 'light') setColorMode('light');
  }, [colorMode, setColorMode]);

  return (
    <Box minH="100vh" bg="bg.canvas">
      <Box
        as="header"
        bg="bg.sidebar"
        color="white"
        px={{ base: 4, md: 6 }}
        py={4}
        position="sticky"
        top={0}
        zIndex={10}
        boxShadow="sm"
      >
        <Flex maxW="720px" mx="auto" align="center" justify="space-between" gap={3}>
          <Box>
            <Box mb={1.5} display="inline-block">
              <BrandLogo variant="full" h="36px" maxW="148px" plate shimmer />
            </Box>
            <Text fontSize="13px" color="whiteAlpha.800">
              {isPortal ? 'Vendor requests' : 'Vendor registration'}
            </Text>
          </Box>
        </Flex>
      </Box>
      <Box as="main" maxW="720px" mx="auto" px={{ base: 4, md: 6 }} py={{ base: 5, md: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
